<script setup lang="ts">
import {computed, useSlots, useTemplateRef} from "vue";
import Button from "primevue/button";
import {Icon} from "@iconify/vue";

const props = withDefaults(
    defineProps<{
        text?: boolean;
        href?: string;
        size?: string;
        rounded?: boolean;
        icon?: object | string;
        loading?: boolean;
    }>(),
    {
        rounded: true,
    },
);

const slots = useSlots();
const button = useTemplateRef("button");
const icon = computed(() => (typeof props.icon === "string" ? {icon: props.icon} : props.icon));
</script>
<template>
    <Button
        ref="button"
        class="flex items-center justify-center font-bold transition"
        :class="{
            'rounded-full': !!rounded,
            icon: !!icon,
            'icon-only': !!icon && !slots.default,
            'icon-top': !!icon && icon.position === 'top',
            'icon-end': !!icon && icon.position === 'end',
            text: !!text,
        }"
        :loading
    >
        <Icon v-if="!!loading" width="20" v-bind="icon" icon="line-md:loading-twotone-loop" />
        <Icon v-if="!!icon && !loading" width="20" v-bind="icon" class="pointer-events-none" />
        <slot />
        <!--        <Badge v-if="badge" :value="badge" :class="badgeClass" :severity="badgeSeverity" :unstyled="unstyled" :pt="ptm('pcBadge')"></Badge>-->
    </Button>
</template>
<style scoped>
button.icon-only,
button.text {
    @apply p-0 !ring-0;
}

button:not(.icon-only):not(.text) {
    @apply px-4 py-2;
}

button:not(.rounded-full) {
    @apply rounded-md;
}

button.icon:not(.icon-only) {
    @apply gap-2;
}

button.icon-end {
    @apply flex-row-reverse;
}
</style>
